import {
  type ConversationMessage,
  MessageMetadataType,
} from '../message/conversation-message.type';
import type { DoNotContactEpisode } from './do-not-contact.type';
import DateUtils from '@/utils/date-utils';

export function mapDoNotContactEvents(
  conversationId: number,
  episodes: DoNotContactEpisode[],
): ConversationMessage[] {
  return episodes.flatMap((episode) => {
    const actions = episode.removedTs ? (['marked', 'removed'] as const) : (['marked'] as const);
    return actions.map((action) => {
      const removed = action === 'removed';
      const actor = removed ? episode.removedBy : episode.createdBy;
      const actorId = removed ? episode.removedByUserProfileId : episode.createdByUserProfileId;
      const name = [actor?.nameFirst, actor?.nameLast].filter(Boolean).join(' ').trim();
      return {
        id: episode.id,
        key: `dnc:${episode.id}:${action}`,
        conversationId,
        content: '',
        createdAt: DateUtils.dateStringToDate(
          removed ? episode.removedTs ?? episode.createTs : episode.createTs,
        ),
        sender: {
          id: actorId,
          name: removed && actorId === null ? 'System' : name || 'Unknown user',
        },
        metadata: { type: MessageMetadataType.DO_NOT_CONTACT, action },
      };
    });
  });
}
